import * as go from 'gojs'
import { layoutGroupSpacing, layoutNodeSpacingAdjustmentForBadge, layoutHorizontalFudge } from '@/utils/constants'

export default function HorizontalLayout () {
  go.GridLayout.call(this)
  this.isViewportSized = false
}

go.Diagram.inherit(HorizontalLayout, go.GridLayout)

HorizontalLayout.prototype.doLayout = function (coll) {
  var ecoll = this.collectParts(coll)
  const parts = []
  ecoll.each(p => {
    parts.push(p)
  })
  parts.sort(this.comparer)
  const padding = this.group.placeholder.padding
  let topLeft = this.group.placeholder.getDocumentPoint(go.Spot.TopLeft)
  topLeft.x += padding.left
  topLeft.y += padding.top
  let x = topLeft.x
  let rowHeight = 0
  parts.forEach(function (p) {
    if (p instanceof go.Link) return
    const itemHeight = p.actualBounds.height + layoutNodeSpacingAdjustmentForBadge
    if (itemHeight > rowHeight) {
      rowHeight = itemHeight
    }
  })
  parts.forEach(function (p) {
    if (p instanceof go.Link) return
    const itemHeight = p.actualBounds.height + layoutNodeSpacingAdjustmentForBadge
    let y = topLeft.y + (p.data.isGroup ? layoutGroupSpacing : 0) + (rowHeight - itemHeight) / 2
    p.moveTo(x, y)
    x += p.actualBounds.width + layoutHorizontalFudge
  })
}



// WEBPACK FOOTER //
// ./src/graph_parts/horizontal_layout.js